import { BaseComponent } from '../BaseComponent';
import { ComponentNames } from 'src/app/helper/componentNames';

export class IdentificationComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.identificationComponent;
    }
    id:string;
    userId:string;
}